import {
  GET_SUPERVISORS_ATTEMPT,
  GET_SUPERVISORS_SUCCESS,
  GET_SUPERVISORS_FAILURE,
} from "../constants";

import { SupervisorsInitialState } from "../../types/supervisors";

const initialState: SupervisorsInitialState = {
  fetchingSupervisorsList: 0,
  errorMessage: "",
  success: true,
  supervisorsList: [],
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    // getSupervisors
    case GET_SUPERVISORS_ATTEMPT:
      return {
        ...state,
        fetchingSupervisorsList: state.fetchingSupervisorsList + 1,
        success: true,
        errorMessage: "",
      };
    case GET_SUPERVISORS_SUCCESS:
      return {
        ...state,
        fetchingSupervisorsList: state.fetchingSupervisorsList - 1,
        success: true,
        errorMessage: "",
        supervisorsList: validData(action.payload.data),
      };
    case GET_SUPERVISORS_FAILURE:
      return {
        ...state,
        fetchingSupervisorsList: state.fetchingSupervisorsList - 1,
        success: false,
        errorMessage: action.payload.error,
      };

    default:
      return state;
  }
};

function validData (data: any[]) {
  return data.filter((element: any) => element.supervisorId)
}
